import { NgModule } from '@angular/core';

import { Modal as BaseModal } from 'angular2-modal';

import { Modal } from './modal';

export const /** @type {?} */ providers: any[] = [
  { provide: BaseModal, useClass: Modal },
  { provide: Modal, useClass: Modal }
];
export class JSNativeModalModule {
/**
 * @return {?}
 */
static getProviders(): any[] {
    return providers;
  }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function JSNativeModalModule_tsickle_Closure_declarations() {
/** @type {?} */
JSNativeModalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
JSNativeModalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
